const styles = (theme) => ({
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  //styles for macOs
  ' _::-webkit-full-page-media, _:future, :root .safari_only': {
    maxHeight: '50px',
  },
  logoImage: {
    marginBottom: '10%',
    width: '68%',
    textAlign: 'center',
  },
  loginInput: {
    marginTop: '8%',
    marginBottom: 0,
    width: '84%',
  },
  loginButton: {
    marginTop: '10%',
    marginBottom: '4.5%',
    width: '42%',
  },
  forgotPassword: {
    fontSize: '12px',
    fontFamily: 'Cerebri Sans Pro Semi Bold',
  },
  helperTextInvisible: {
    visibility: 'hidden',
  },
  loginWrapperMobile: {
    margin: '30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 60px)',
  },
  loginWrapperDesktop: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 60px)',
    maxWidth: '400px',
    paddingLeft: '250px',
  },
  desktopLogin: {
    height: '100vh',
    width: '100%',
    display: 'flex',
  },
  mobileLogin: {
    height: 'calc(100vh - 60px)',
  },
  pictureWrapper: {
    width: 'calc(100% - 650px)',
    marginTop: '50px',
    textAlign: 'center',
  },
  lampPictureWrapper: {
    height: 'calc(100vh - 55px)',
  },
  '@media screen and (max-width: 1224px) and (orientation: landscape)': {
    //styles for macOs
    ' _::-webkit-full-page-media, _:future, :root .safari_only': {
      maxHeight: '70px',
    },
    loginWrapperMobile: {
      height: '100%',
    },
    logoImage: {
      marginBottom: '4%',
      width: '28%',
    },
    loginInput: {
      marginTop: '1%',
      width: '60%',
    },
    loginButton: {
      marginTop: '1%',
      marginBottom: '1%',
      width: '42%',
    },
  },
  '@media screen and (max-width: 800px) and (orientation: landscape)': {
    loginInput: {
      marginTop: '0',
      width: '68%',
    },
  },
  '@media screen and (max-width: 900px) and (orientation: landscape) and (max-height: 400px)':
    {
      logoImage: {
        marginBottom: '2%',
        width: '20%',
      },
      loginInput: {
        marginTop: '0',
        width: '68%',
      },
    },
})

export default styles
